import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Header.css';

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      if (isHomePage) {
        // En home: transparente hasta salir del hero (80% del viewport)
        setIsScrolled(window.scrollY > window.innerHeight * 0.8);
      } else {
        // En otras páginas: siempre con fondo
        setIsScrolled(true);
      }
    };

    handleScroll(); // Ejecutar al cargar
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHomePage]);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''} ${!isHomePage ? 'header-with-bg' : ''}`}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <img src="/images/logo.png" alt="MARCUS Security Logo" />
            <span className="logo-text">
              <strong>Marcus</strong> Security
            </span>
          </Link>

          <nav className={`nav ${isMobileMenuOpen ? 'active' : ''}`}>
            <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
              Inicio
            </Link>
            <Link to="/servicios" className={location.pathname === '/servicios' ? 'active' : ''}>
              Servicios
            </Link>
            <Link to="/empresa" className={location.pathname === '/empresa' ? 'active' : ''}>
              Empresa
            </Link>
            <Link to="/contacto" className="btn-contact">
              Contacto
            </Link>
          </nav>

          <button 
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;